import { Navigate, Outlet, type RouteObject } from 'react-router-dom';

import { AuthorizedOutlet } from '@myphx-engineering/auth/client';

import { ProfileProvider } from '../../contexts/ProfileProvider';
import routes from '../app-routes';

import NonDrxPriorAuthorizationOrderDetailsRoute from './NonDrxPriorAuthorizationOrderDetailsRoute';
import PriorAuthorizationRoute from './PriorAuthorizationRoute';

const priorAuthorizationRoutes: RouteObject[] = [
    {
        path: routes.priorAuthorization.root,
        element: <AuthorizedOutlet />,
        children: [
            {
                path: routes.priorAuthorization.priorAuthorizationId.root,
                element: (
                    <ProfileProvider>
                        <Outlet />
                    </ProfileProvider>
                ),
                children: [
                    {
                        index: true,
                        element: (
                            <Navigate
                                to={
                                    routes.priorAuthorization
                                        .priorAuthorizationId.status
                                }
                            />
                        ),
                    },
                    {
                        path: routes.priorAuthorization.priorAuthorizationId
                            .status,
                        element: <PriorAuthorizationRoute />,
                    },
                    {
                        path: routes.priorAuthorization.priorAuthorizationId
                            .details,
                        element: <NonDrxPriorAuthorizationOrderDetailsRoute />,
                    },
                ],
            },
        ],
    },
];

export default priorAuthorizationRoutes;
